import {
    CREATE_UNIT_MASTER_FAILURE,
    CREATE_UNIT_MASTER_REQUEST,
    CREATE_UNIT_MASTER_SUCCESS,
    CREATE_USER_FORM_UNIT_MASTER,
    DELETE_UNIT_MASTER_FAILURE,
    DELETE_UNIT_MASTER_REQUEST,
    DELETE_UNIT_MASTER_SUCCESS,
    FETCH_SINGLE_UNIT_MASTER_FAILURE,
    FETCH_SINGLE_UNIT_MASTER_REQUEST,
    FETCH_SINGLE_UNIT_MASTER_SUCCESS,
    FETCH_UNIT_MASTER_BY_COMPANYID_FAILURE,
    FETCH_UNIT_MASTER_BY_COMPANYID_REQUEST,
    FETCH_UNIT_MASTER_BY_COMPANYID_SUCCESS,
    FETCH_UNIT_MASTER_FAILURE,
    FETCH_UNIT_MASTER_REQUEST,
    FETCH_UNIT_MASTER_SUCCESS,
    UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_FAILURE,
    UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_REQUEST,
    UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_SUCCESS,
    UNIT_MASTER_USERFORM_RESET,
    UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE,
    UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST,
    UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS,
    UPDATE_UNIT_MASTER_REQUEST,
    UPDATE_UNIT_MASTER_SUCCESS
} from './unitMaster.actionsType';

export const UNIT_MASTER = 'unitMaster';

let initialState = {
    loading: false,
    unitMaster: [],
    unitMasterByID: [],
    userform: {},
    propertyList: [],
    areaList: {},
    selectedUnit: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let unitMasterReducer = (state = initialState, action) => {
    let { type, updatePayload } = action;

    switch (type) {
        case FETCH_UNIT_MASTER_REQUEST:
        case UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST:
        case CREATE_UNIT_MASTER_REQUEST:
        case UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_REQUEST:
        case FETCH_SINGLE_UNIT_MASTER_REQUEST:
        case UPDATE_UNIT_MASTER_REQUEST:
        case FETCH_UNIT_MASTER_BY_COMPANYID_REQUEST:
        case DELETE_UNIT_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_UNIT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                unitMaster: updatePayload
            };
        case FETCH_UNIT_MASTER_BY_COMPANYID_SUCCESS:
            return {
                ...state,
                loading: false,
                unitMasterByID: updatePayload
            };
        case UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS:
            return {
                ...state,
                loading: false,
                propertyList: updatePayload
            };

        case CREATE_UNIT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };

        case UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_SUCCESS:
            return {
                ...state,
                loading: false,
                areaList: updatePayload.map((item) => {
                    return {
                        fldId: item.fldId,
                        country: item.fldCountry,
                        state: item.fldState,
                        city: item.fldCity,
                        area: item.fldArea,
                        pincode: item.fldPincode,
                        fldStateCode: item.fldStateCode
                    };
                })
            };
        case FETCH_SINGLE_UNIT_MASTER_SUCCESS:
            return {
                ...state,
                selectedUnit: updatePayload,
                loading: false,
                userform: {
                    unitType: updatePayload.fldFKUnitCategory,
                    code: updatePayload.fldCode,
                    shortName: updatePayload.fldShortName,
                    name: updatePayload.fldName,
                    address1: updatePayload.fldAddress1,
                    address2: updatePayload.fldAddress2,
                    area: updatePayload.fldFKArea,
                    gstNo: updatePayload.fldGSTNo,
                    panNo: updatePayload.fldPANNo,
                    CName: updatePayload.fldContactPerNme,
                    mobile: updatePayload.fldMobileNo,
                    mail: updatePayload.fldMailId
                }
            };
        case UPDATE_UNIT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedUnit: {}
            };
        case DELETE_UNIT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                propertyList: {},
                areaList: {},
                selectedUnit: {}
            };
        case FETCH_UNIT_MASTER_FAILURE:
        case FETCH_UNIT_MASTER_BY_COMPANYID_FAILURE:
        case UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE:
        case CREATE_UNIT_MASTER_FAILURE:
        case UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_FAILURE:
        case FETCH_SINGLE_UNIT_MASTER_FAILURE:
        case DELETE_UNIT_MASTER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_UNIT_MASTER:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [updatePayload.key]: updatePayload.value
                }
            };
        case UNIT_MASTER_USERFORM_RESET:
            return {
                ...state,
                userform: {}
                // propertyList: {},
                // areaList: {},
                // selectedUnit: {}
            };
        default:
            return state;
    }
};
